import { IconButton, Tooltip } from '@mui/material';
import { Brightness4, Brightness7 } from '@mui/icons-material';
import { useTheme } from '~/lib/utils/theme-context';

export function ThemeToggle() {
  const { resolvedTheme, toggleTheme } = useTheme();

  const label = resolvedTheme === 'dark' ? 'التبديل إلى الوضع الفاتح' : 'التبديل إلى الوضع الداكن';
  const Icon = resolvedTheme === 'dark' ? Brightness7 : Brightness4;

  return (
    <Tooltip title={label}>
      <IconButton
        onClick={toggleTheme}
        aria-label={label}
        sx={{
          color: 'primary.contrastText',
          '&:hover': {
            bgcolor: 'rgba(255, 255, 255, 0.1)',
          },
        }}
      >
        <Icon />
      </IconButton>
    </Tooltip>
  );
}
